import {
	Alert,
	Box,
	Button,
	Grid,
	IconButton,
	InputAdornment,
	OutlinedInput,
	Snackbar,
	Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import {
	getUser,
	resendCode,
	updateUser,
} from '../../../services/api/apiManager';
import { logoutFunc } from '../../../layouts/sidebar/SideBar';
import * as Yup from 'yup';
import {
	CallOutlined,
	EmailOutlined,
	LockOutlined,
	PersonOutline,
	SaveOutlined,
	SecurityOutlined,
	Visibility,
	VisibilityOff,
} from '@mui/icons-material';
import MaskedInput from 'react-text-mask';

const profilePageSx = {
	background: '#f5f8fd',
	minHeight: 'calc(100vh - 120px)',
	padding: { xs: '12px', md: '12px' },
	fontFamily: 'Poppins',
};

const sectionCardSx = {
	background: '#fff',
	border: '1px solid #e0e8f3',
	borderRadius: '8px',
	padding: { xs: '16px', md: '22px' },
	boxShadow: '0 8px 22px rgba(15, 35, 70, 0.08)',
};

const profileLabelSx = {
	fontFamily: 'Poppins',
	fontSize: '12px',
	fontWeight: 600,
	color: '#10254d',
	mb: '7px',
};

const profileInputSx = {
	height: 42,
	borderRadius: '6px',
	fontFamily: 'Poppins',
	fontSize: '13px',
	color: '#0b2450',
	background: '#fff',
	'& .MuiOutlinedInput-notchedOutline': {
		borderColor: '#d6e2f2',
	},
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: '#b9cbe3',
	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: '#2f6edb',
		borderWidth: '1px',
	},
	'& .MuiInputBase-input': {
		padding: '10px 12px',
		boxSizing: 'border-box',
		fontFamily: 'Poppins',
		fontSize: '13px',
	},
	'& .MuiInputAdornment-root svg': {
		color: '#6f7f9d',
		fontSize: 19,
	},
};

const sectionIconSx = (tone) => ({
	width: 40,
	height: 40,
	borderRadius: '50%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	background: tone === 'security' ? '#e8fbfb' : '#eef4ff',
	color: tone === 'security' ? '#11aaa5' : '#2f6edb',
});

function ManageProfile() {
	const defaultTheme = createTheme();
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [wrongCurrentPassword, setwrongCurrentPassword] = useState(false);
	const [showPassword, setShowPassword] = React.useState(false);
	const [errors, setErrors] = useState({});
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};
	const schema = Yup.object().shape({
		fname: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		lname: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'Name should contain only alphabets'),
		email: Yup.string().email('Invalid E-mail').required('Required*'),
		contact: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Incomplete '
		),
	});

	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};
	const handleSnackbaErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
		setwrongCurrentPassword(false);
	};

	const navigate = useNavigate();
	const [fname, setFname] = useState('');
	const [lname, setLname] = useState('');
	const [contact, setContact] = useState('');
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [password2, setPassword2] = useState('');
	const [flag, setflag] = useState(false);
	const [flag1, setflag1] = useState(false);
	const [flag2, setflag2] = useState(true);

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		if (name == 'fname') {
			setFname(value);
			setflag2(false);
		} else if (name == 'lname') {
			setflag2(false);
			setLname(value);
		} else if (name == 'contact') {
			setflag2(false);
			setContact(value);
		} else if (name == 'email') {
			setflag(true);
			setflag2(false);
			setEmail(value);
		}

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '',
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message,
				}));
			});
	};
	const fetchuser = async () => {
		try {
			const response = await getUser();
			if (response?.status === 200) {
				const u = response?.data[0];
				setFname(u?.first_name);
				setLname(u?.last_name);
				setEmail(u?.email);
				setContact(u.UserContactNo);
			} else {
				setFname('');
				setLname('');
				setEmail('');
				setContact('');
			}
		} catch (error) {
			console.error('Error fetching user:', error);
		}
	};
	const updateUserData = async () => {
		try {
			var user = {};
			if (flag1) {
				user = {
					email: email,
					password: password,
					password2: password2,
				};
			} else if (flag && flag1) {
				user = {
					email: email,
					first_name: fname,
					last_name: lname,
					UserContactNo: contact,
					password: password,
					password2: password2,
				};
			} else if (flag && !flag1) {
				user = {
					email: email,
					first_name: fname,
					last_name: lname,
					UserContactNo: contact,
				};
			} else {
				user = {
					first_name: fname,
					last_name: lname,
					UserContactNo: contact,
				};
			}
			const response = await updateUser(user);
			if (response?.status === 200) {
				const u = response?.data;
				setFname(u?.first_name);
				setLname(u?.last_name);
				setEmail(u?.email);
				setContact(u?.UserContactNo);
				localStorage.removeItem('userName');
				localStorage.setItem('userName', u?.last_name + ',' + u?.first_name);
				if (!flag && !flag1) {
					window.location.reload();
				}
				setOpenSnackbar(true);
				if (flag) {
					const data = { email: email };
					const res = await resendCode(data);
					if (res?.status === 201) {
						logoutFunc();
						navigate('/verification');
					}
				}
				if (flag1) {
					logoutFunc();
					navigate('/');
				}
			} else if (
				response?.response?.data?.non_field_errors[0] ==
				'Invalid credentials, Try Again Please'
			) {
				setwrongCurrentPassword(true);
			} else {
				setOpenSnackbarError(true);
			}
		} catch (error) {
			setOpenSnackbarError(true);
		}
	};
	useEffect(() => {
		fetchuser();
	}, []);

	const renderError = (name) =>
		errors[name] ? (
			<Typography
				sx={{
					fontFamily: 'Poppins',
					fontSize: '10px',
					color: '#d61b1b',
					mt: '4px',
				}}
			>
				{errors[name]}
			</Typography>
		) : null;

	const isUpdateDisabled =
		errors.email || errors.fname || errors.lname || errors.contact || flag2;

	return (
		<ThemeProvider theme={defaultTheme}>
			<Box sx={profilePageSx}>
				<Box sx={{ mb: 2.5 }}>
					<Typography
						sx={{
							fontFamily: 'Poppins',
							fontSize: { xs: '20px', md: '24px' },
							fontWeight: 700,
							color: '#0b2450',
							lineHeight: 1.2,
						}}
					>
						Profile Settings
					</Typography>
					<Typography
						sx={{
							fontFamily: 'Poppins',
							fontSize: '13px',
							color: '#526684',
							mt: 0.75,
						}}
					>
						Manage your account information and security
					</Typography>
				</Box>

				<Grid container spacing={2}>
					<Grid item xs={12} lg={7.2}>
						<Box sx={{ ...sectionCardSx, height: '100%' }}>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
								<Box sx={sectionIconSx('account')}>
									<PersonOutline sx={{ fontSize: 22 }} />
								</Box>
								<Box>
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontSize: '16px',
											fontWeight: 700,
											color: '#0b2450',
										}}
									>
										Account Information
									</Typography>
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontSize: '12px',
											color: '#526684',
											mt: 0.25,
										}}
									>
										Update your personal and contact details.
									</Typography>
								</Box>
							</Box>
							<Box sx={{ borderTop: '1px solid #e7edf5', mt: 2, pt: 2.5 }}>
								<Grid container spacing={2.5}>
									<Grid item xs={12} md={6}>
										<Typography sx={profileLabelSx}>First Name</Typography>
										<OutlinedInput
											size="small"
											type="text"
											fullWidth
											value={fname}
											onChange={handleInputChange}
											name="fname"
											sx={profileInputSx}
											error={Boolean(errors.fname)}
											startAdornment={
												<InputAdornment position="start">
													<PersonOutline />
												</InputAdornment>
											}
										/>
										{renderError('fname')}
									</Grid>
									<Grid item xs={12} md={6}>
										<Typography sx={profileLabelSx}>Last Name</Typography>
										<OutlinedInput
											type="text"
											size="small"
											fullWidth
											value={lname}
											onChange={handleInputChange}
											name="lname"
											sx={profileInputSx}
											error={Boolean(errors.lname)}
											startAdornment={
												<InputAdornment position="start">
													<PersonOutline />
												</InputAdornment>
											}
										/>
										{renderError('lname')}
									</Grid>
									<Grid item xs={12} md={6}>
										<Typography sx={profileLabelSx}>
											Contact #{' '}
											<Box component="span" sx={{ color: '#d61b1b' }}>
												*
											</Box>
										</Typography>
										<Box sx={{ position: 'relative' }}>
											<CallOutlined
												sx={{
													position: 'absolute',
													top: '50%',
													left: 13,
													transform: 'translateY(-50%)',
													color: '#6f7f9d',
													fontSize: 19,
													zIndex: 1,
												}}
											/>
											<MaskedInput
												required
												name="contact"
												value={contact}
												onChange={handleInputChange}
												placeholder="Enter contact number"
												mask={[
													'(',
													/\d/,
													/\d/,
													/\d/,
													')',
													' ',
													/\d/,
													/\d/,
													/\d/,
													'-',
													/\d/,
													/\d/,
													/\d/,
													/\d/,
												]}
												style={{
													width: '100%',
													borderRadius: '6px',
													height: '42px',
													border: errors.contact
														? '1px solid #d61b1b'
														: '1px solid #d6e2f2',
													padding: '10px 12px 10px 42px',
													outline: 'none',
													boxSizing: 'border-box',
													fontFamily: 'Poppins',
													fontSize: '13px',
													color: '#0b2450',
												}}
											/>
										</Box>
										{renderError('contact')}
									</Grid>
									<Grid item xs={12} md={6}>
										<Typography sx={profileLabelSx}>
											Email
											<Box component="span" sx={{ color: '#d61b1b' }}>
												*
											</Box>
										</Typography>
										<OutlinedInput
											name="email"
											type="email"
											fullWidth
											disabled
											size="small"
											inputProps={{
												autoComplete: '',
											}}
											value={email}
											onChange={handleInputChange}
											sx={{
												...profileInputSx,
												background: '#fbfdff',
												'&.Mui-disabled': {
													color: '#0b2450',
													WebkitTextFillColor: '#0b2450',
												},
											}}
											error={Boolean(errors.email)}
											startAdornment={
												<InputAdornment position="start">
													<EmailOutlined />
												</InputAdornment>
											}
										/>
										{renderError('email')}
									</Grid>
								</Grid>
							</Box>
						</Box>
					</Grid>

					<Grid item xs={12} lg={4.8}>
						<Box sx={{ ...sectionCardSx, height: '100%' }}>
							<Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
								<Box sx={sectionIconSx('security')}>
									<SecurityOutlined sx={{ fontSize: 22 }} />
								</Box>
								<Box>
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontSize: '16px',
											fontWeight: 700,
											color: '#0b2450',
										}}
									>
										Security Settings
									</Typography>
									<Typography
										sx={{
											fontFamily: 'Poppins',
											fontSize: '12px',
											color: '#526684',
											mt: 0.25,
										}}
									>
										Update your password to keep your account secure.
									</Typography>
								</Box>
							</Box>
							<Box sx={{ borderTop: '1px solid #e7edf5', mt: 2, pt: 2.5 }}>
								<Grid container spacing={2.5}>
									<Grid item xs={12}>
										<Typography sx={profileLabelSx}>Current Password</Typography>
										<OutlinedInput
											fullWidth
											required
											size="small"
											id="password"
											inputProps={{
												autoComplete: 'new-password',
											}}
											value={password}
											onChange={(e) => setPassword(e.target.value)}
											sx={profileInputSx}
											type={showPassword ? 'text' : 'password'}
											placeholder="Enter current password"
											startAdornment={
												<InputAdornment position="start">
													<LockOutlined />
												</InputAdornment>
											}
											endAdornment={
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
														sx={{ color: '#6f7f9d' }}
													>
														{showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											}
										/>
									</Grid>
									<Grid item xs={12}>
										<Typography sx={profileLabelSx}>Change Password</Typography>
										<OutlinedInput
											fullWidth
											required
											size="small"
											value={password2}
											onChange={(e) => {
												setPassword2(e.target.value);
												setflag1(true);
												setflag2(false);
											}}
											sx={profileInputSx}
											type={showPassword ? 'text' : 'password'}
											placeholder="Enter new password"
											startAdornment={
												<InputAdornment position="start">
													<LockOutlined />
												</InputAdornment>
											}
											endAdornment={
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
														sx={{ color: '#6f7f9d' }}
													>
														{showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											}
										/>
									</Grid>
								</Grid>
							</Box>
						</Box>
					</Grid>
				</Grid>

				<Box width="100%" display="flex" justifyContent="flex-end" mt={2}>
					<Button
						disabled={isUpdateDisabled}
						startIcon={<SaveOutlined />}
						sx={{
							height: 40,
							minWidth: 140,
							backgroundColor: isUpdateDisabled ? '#d9dee7' : '#1f66df',
							color: 'white',
							fontFamily: 'Poppins',
							fontSize: '13px',
							fontWeight: 600,
							borderRadius: '6px',
							textTransform: 'none',
							boxShadow: isUpdateDisabled
								? 'none'
								: '0 6px 14px rgba(31, 102, 223, 0.24)',
							'&:hover': {
								background: isUpdateDisabled ? '#d9dee7' : '#185ac7',
								boxShadow: isUpdateDisabled
									? 'none'
									: '0 6px 14px rgba(31, 102, 223, 0.24)',
							},
						}}
						onClick={() => updateUserData()}
					>
						Save Changes
					</Button>
				</Box>
			</Box>

			<Snackbar
				open={openSnackbar}
				autoHideDuration={6000}
				onClose={handleSnackbarClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbarClose}
					severity="success"
					sx={{
						backgroundColor: '#3EAE4D',
						fontSize: '15px',
						padding: '15px',
						color: 'white',
						'& .MuiAlert-icon': {
							color: 'white',
						},
					}}
				>
					Updated Successfully
				</Alert>
			</Snackbar>
			<Snackbar
				open={openSnackbarError}
				autoHideDuration={6000}
				onClose={handleSnackbaErrorClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbaErrorClose}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '17px',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white',
						},
					}}
				>
					Error
				</Alert>
			</Snackbar>
			<Snackbar
				open={wrongCurrentPassword}
				autoHideDuration={2000}
				onClose={handleSnackbaErrorClose}
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
			>
				<Alert
					onClose={handleSnackbaErrorClose}
					severity="error"
					sx={{
						backgroundColor: 'red',
						fontSize: '15px',
						fontWeight: '400',
						color: 'white',
						fontFamily: 'Poppins',
						padding: '15px',
						'& .MuiAlert-icon': {
							color: 'white',
						},
					}}
				>
					Invalid crenditials, Try Again Please
				</Alert>
			</Snackbar>
		</ThemeProvider>
	);
}

export default ManageProfile;
